import DropzoneContainer from "../../../Component/BonusUi/Dropzone/Dropzone"

const Dropzone = () => {
  return (
    <div className='page-body'>
      <DropzoneContainer />
    </div>
  )
}

export default Dropzone